import { useDispatch } from "react-redux"
import { WishlistIcon } from "../../../../assets"
import styles from "./style.module.css"
import { setCartVisibility } from "../../../../redux/slices/cartVisibilitySlice"

export const WishlistButton = () =>{

    const dispatch = useDispatch();

    return(

        <div 
        className={styles.container}
        onClick={() => dispatch(setCartVisibility(false))}
        >
            <WishlistIcon className={styles.icon}/>
            {/* Wishlist */}
            OpenX
        </div>

    )

}